import UnitQuizSkillResult from './model';

const reviver = ([key, val]) => [key, val];

const create = (data) => new UnitQuizSkillResult(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/UnitQuiz/model/UnitQuizResult/UnitQuizSkillResult/create.js